import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { SALVA_ACESSO_PESSOA, INICIA_ACESSO_PESSOA, BUSCA_ACESSO_PESSOA_EDICAO, REMOVE_ACESSO_PESSOA,
         LISTA_CONFIGURACAO_PONTO_PESSOA, LISTA_LOCAIS_POR_CLIENTE_ACESSO_PESSOA, CONSULTA_CPF, LISTA_ACESSO_PESSOA } from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import requisicaoApiSeguranca from 'util/ApiSeguranca';
import {  userSignOut } from "actions/Auth";
import { showAuthMessage, 
         exibirMensagemErro, 
         salvaAcessoPessoaSucesso,
         removeAcessoPessoaSucesso, 
         inicioAcessoPessoaSucesso, 
         iniciaAcessoPessoa,
         listaLocaisSucesso,
         consultaCpfSucesso,
         buscaAcessoPessoaEdicaoSucesso,
         listaConfiguracaoPontoPessoaSucesso,
         listaAcessoPessoaSucesso } from "actions/AcessoPessoa";

/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/         

  const getAcessosPessoa = async () =>
    await requisicaoApi.get('/acessosPessoa')
    .then(resposta => resposta)
    .catch(error => error);

  // Combo "cliente" migrado pro endpoint sem paginação da Uzerpass.Seguranca (GET /clientes
  // do legado quebra pra usuário criado só na nova API, sem claim idUsuario — ver
  // docs/plano-integracao-api-seguranca.md). Mapeia nome->nomeRazaoSocial pra não precisar
  // mexer em mais nada (reducer/preparaListaParaCombo já esperam esse campo).
  const getClientes = async () =>
    await requisicaoApiSeguranca.get('/me/clientes/todos')
      .then(resposta => ({ ...resposta, data: (resposta.data || []).map(c => ({ id: c.id, nomeRazaoSocial: c.nome })) }))
      .catch(error => error);       

  const getAcessoPessoaEdicao = async (id) =>
    await requisicaoApi.get('/acessosPessoa/' + id)
    .then(resposta => resposta)
    .catch(error => error);

  const getListaPerfisPorCliente = async (cliente) => 
    await requisicaoApi.get('/perfis/cliente/' + cliente)
    .then(resposta => resposta)
    .catch(error => error);   
    
  const getListaLocaisControladosPorCliente = async (cliente) => 
    await requisicaoApi.get('/locais/cliente/' + cliente)
    .then(resposta => resposta)
    .catch(error => error);    
    
  const getlistaConfiguracaoPontoPessoa = async (idLocal, idPessoa) => 
    await requisicaoApi.get('/acessosPessoa/vinculoPontoAcesso/' + idLocal + '/' + idPessoa)
    .then(resposta => resposta)
    .catch(error => error);
    
  const getCpf = async (cpf) =>
    await requisicaoApi.get('/util/pessoaFisica/' + cpf)
    .then(resposta => resposta)
    .catch(error => error);    

    const getListaAcessoPessoa = async (usuarioFiltro, ambienteFiltro, pontoFiltro) => 
    await requisicaoApi.get('/acessosPessoa?Usuario=' +  usuarioFiltro + '&Ambiente=' + ambienteFiltro + '&PontoAcesso=' + pontoFiltro)
    .then(resposta => resposta)
    .catch(error => error);  

/*#################################################################################################################*/
/* ------------------------------------- Requests do tipo POST, PUT E DELETE --------------------------------------*/     

  const adicionaAcessoPessoaRequest = async (acessoPessoa, listaPontosAssociados) => await requisicaoApi.post('/acessosPessoa', 
  {
    "id": acessoPessoa.id,
    "idCliente": acessoPessoa.idCliente,
    "idLocalControlado": acessoPessoa.idLocalControlado,
    "numeroCpf": acessoPessoa.numeroCpf,
    "nomePessoa": acessoPessoa.nomePessoa,
    "idPessoa": acessoPessoa.idPessoa,
    "idLocalControlado": acessoPessoa.idLocalControlado,
    "pontosAssociados": listaPontosAssociados
  })
  .then(resposta => resposta)
  .catch(error => error);

  const atualizaAcessoPessoaRequest = async (acessoPessoa, listaPontosAssociados) => await requisicaoApi.put('/acessosPessoa', 
  {
    "id": acessoPessoa.id,
    "idCliente": acessoPessoa.idCliente,
    "idLocalControlado": acessoPessoa.idLocalControlado,
    "numeroCpf": acessoPessoa.numeroCpf,
    "nomePessoa": acessoPessoa.nomePessoa,
    "idPessoa": acessoPessoa.idPessoa,
    "idLocalControlado": acessoPessoa.idLocalControlado,
    "pontosAssociados": listaPontosAssociados
  })
  .then(resposta => resposta)
  .catch(error => error);

  const deleteAcessoPessoaRequest = async (id) =>
  await requisicaoApi.delete('/acessosPessoa?id=' + id)
  .then(resposta => resposta)
  .catch(error => error);    

/*#################################################################################################################*/
/* --------------------------------------------- Functions do tipo GET --------------------------------------------*/
/*#################################################################################################################*/   

function* fnIniciaAcessoPessoa() {
  try {
    const listagemGrid = yield call(getAcessosPessoa);

    if(listagemGrid.data)
    {
      const clientes = yield call(getClientes);

      if(clientes.data) {
        const clienteFixo = localStorage.getItem('idClienteFixado');

        if(clienteFixo !== "" && clienteFixo !== "0" && clienteFixo !== undefined)
        {
          const locais = yield call(getListaLocaisControladosPorCliente, parseInt(clienteFixo));
          yield put(inicioAcessoPessoaSucesso(listagemGrid.data, clientes.data, locais.data));
        }
        else
        {
          yield put(inicioAcessoPessoaSucesso(listagemGrid.data, clientes.data, null));
        }
      }
    }
    else {
      if(listagemGrid.response.status === 401 && listagemGrid.response.config.xsrfHeaderName === "X-XSRF-TOKEN")
      {
        yield put(userSignOut());
      }
      else
      {
        yield put(showAuthMessage('Ocorreu um erro ao listar acessosPessoa'));
      }
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* fnListaLocaisPorCliente({ payload }) {
  try {
    const cliente = payload.idCliente;
    const retorno = yield call(getListaLocaisControladosPorCliente, cliente);

    if(retorno.data)
    {
      yield put(listaLocaisSucesso(retorno.data));
    }
    else
    {
      yield put(showAuthMessage('Ocorreu um erro ao retornar os dados de locais controlados do cliente: ' + cliente));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }    
}

function* fnlistaConfiguracaoPontoPessoa({ payload }) {
  try {
    const idLocal = payload.idLocal;
    const idPessoa = payload.idPessoa
    const retorno = yield call(getlistaConfiguracaoPontoPessoa, idLocal, 1);

    if(retorno.data)
    {
      yield put(listaConfiguracaoPontoPessoaSucesso(retorno.data));
    }
    else
    {
      yield put(showAuthMessage('Ocorreu um erro ao retornar os dados de pontos de acesso do local: ' + idLocal));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }    
} 

function* fnConsultaCpf({ payload }) {
  try {
    const cpf = payload;
    const retorno = yield call(getCpf, cpf);

    if(retorno.data)
    {
      yield put(consultaCpfSucesso(retorno.data));
    }
    else
    {
      yield put(showAuthMessage('Ocorreu um erro ao consultar o CPF: ' + cpf));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}  

  function* fnBuscaAcessoPessoaEdicao({ payload }) {
    try {
      const id = payload;
      const retorno = yield call(getAcessoPessoaEdicao, id);
      const locais = yield call(getListaLocaisControladosPorCliente, retorno.data.idCliente);
  
      if(retorno.data)
      {
        yield put(buscaAcessoPessoaEdicaoSucesso(retorno.data, locais.data));
      }
      else
      {
        yield put(showAuthMessage('Ocorreu um erro ao retornar os dados do acessoPessoa: ' + id));
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  }
  
/*#################################################################################################################*/
/* ---------------------------------- Functions do tipo POST, PUT E DELETE ----------------------------------------*/
/*#################################################################################################################*/  


  function* fnSalvaAcessoPessoa({ payload }) {
  try {

    const acessoPessoa = payload.acessoPessoa;
    const listaPontosAssociados = payload.listaPontosAssociados;
    var resultado = "";

      if(acessoPessoa.id === 0) {
        const retorno = yield call(adicionaAcessoPessoaRequest, acessoPessoa, listaPontosAssociados);
        resultado = retorno;
      }
      else {
        const retorno = yield call(atualizaAcessoPessoaRequest, acessoPessoa, listaPontosAssociados);
        resultado = retorno;
      }

    if(resultado.data)
    {
      if(resultado.data.sucesso) {
        yield put(iniciaAcessoPessoa());
        yield put(salvaAcessoPessoaSucesso(resultado.data.mensagem));
      }
      else {
        yield put(exibirMensagemErro(resultado.data.mensagem));
      }
    }
    else
    {
      if(resultado.response.data)
      {
        if(resultado.response.data.inconsistencias.length > 0)
        {
          const inconsistencia = resultado.response.data.inconsistencias[0];
          var propCorrigir = inconsistencia.propriedade;
          var indexPonto = propCorrigir.indexOf(".");
          propCorrigir = propCorrigir.substr(indexPonto + 1);
          
          yield put(exibirMensagemErro(inconsistencia.mensagem + " - " + propCorrigir));
        }
        else
        {
          yield put(exibirMensagemErro("Ocorreu um erro interno."));
        }
      }
      else {
        yield put(exibirMensagemErro("Ocorreu um erro interno."));
      }
    }          

  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* fnRemoveAcessoPessoa({ payload }) {
  try {

    const id = payload;
    const retorno = yield call(deleteAcessoPessoaRequest, id);
    
    if(retorno.data)
    {
      if(retorno.data.sucesso) {
        yield put(iniciaAcessoPessoa());
        yield put(removeAcessoPessoaSucesso(retorno.data.mensagem));
      }
      else {
        yield put(exibirMensagemErro(retorno.data.mensagem));
      }
    }
    else
    {
      if(retorno.response.data.mensagem)
      {
        yield put(exibirMensagemErro(retorno.response.data.inconsistencias[0].mensagem));
      }
      else
      {
        yield put(exibirMensagemErro("Erro desconhecido"));
      }
    }        
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* fnListaAcessoPessoa({ payload }) {
  try {
    const usuarioFiltro = payload.usuario;
    const ambienteFiltro = payload.ambiente;
    const pontoFiltro = payload.ponto;
    const retorno = yield call(getListaAcessoPessoa, usuarioFiltro, ambienteFiltro, pontoFiltro);

    if(retorno.data)
    {
      yield put(listaAcessoPessoaSucesso(retorno.data));
    }
    else
    {
      yield put(showAuthMessage('Ocorreu um erro ao retornar os dados de acesso pessoa'));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }    
} 

/*#################################################################################################################*/
/* -------------------------------------------- Chamadas de Funções -----------------------------------------------*/
/*#################################################################################################################*/  

export function* iniciaAcoesAcessoPessoa() {
  yield takeEvery(INICIA_ACESSO_PESSOA, fnIniciaAcessoPessoa);
}

export function* consultarCpf() {
  yield takeEvery(CONSULTA_CPF, fnConsultaCpf);
}

export function* salvaAcessoPessoa() {
  yield takeEvery(SALVA_ACESSO_PESSOA, fnSalvaAcessoPessoa);
}

export function* buscaAcessoPessoaEdicao() {
  yield takeEvery(BUSCA_ACESSO_PESSOA_EDICAO, fnBuscaAcessoPessoaEdicao);
}

export function* removeAcessoPessoa() {
  yield takeEvery(REMOVE_ACESSO_PESSOA, fnRemoveAcessoPessoa);
}

export function* listaLocaisPorCliente() {
  yield takeEvery(LISTA_LOCAIS_POR_CLIENTE_ACESSO_PESSOA, fnListaLocaisPorCliente)
}

export function* listaConfiguracaoPontoPessoa() {
  yield takeEvery(LISTA_CONFIGURACAO_PONTO_PESSOA, fnlistaConfiguracaoPontoPessoa)
}

export function* listaAcessoPessoa() {
  yield takeEvery(LISTA_ACESSO_PESSOA, fnListaAcessoPessoa)
}

/*#################################################################################################################*/
/* ------------------------------------------- Registro de Chamadas -----------------------------------------------*/
/*#################################################################################################################*/  

export default function* rootSaga() {
  yield all([fork(iniciaAcoesAcessoPessoa),
             fork(consultarCpf), 
             fork(salvaAcessoPessoa), 
             fork(buscaAcessoPessoaEdicao),
             fork(removeAcessoPessoa),
             fork(listaLocaisPorCliente),
             fork(listaConfiguracaoPontoPessoa),
             fork(listaAcessoPessoa)
            ]);
}